import { useNavigate } from 'react-router-dom';

import { asyncSimpleModal } from '../../lib/common';
import useCreateCategory from '../queries/category/useCreateCategory';
import { CATEGORY_CREATE_MANAGEMENT_URL_PATH } from '../../constants/service/common/urlConstants';
import { CATEGORY_ATTACHMENTS_IMAGE_TYPE } from '../../constants/service/app/categoryConstants';

const useCategoryCreateModal = (form) => {
  const navigate = useNavigate();

  const { createCategory } = useCreateCategory();

  const onClickSaveConfirmBtn = async () => {
    const result = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 생성',
      message: '카테고리를 신규 생성하시겠습니까?',
    });

    if (!result) return;

    form.validateFields((err, values) => {
      if (err) return;

      createCategory.mutate({
        ...values,
        memo: values.memo || null,
        categoryAttachments: values.categoryAttachments?.map(({ path }) => ({
          type: CATEGORY_ATTACHMENTS_IMAGE_TYPE.NORMAL,
          path,
        })),
      });
    });
  };

  const onClickCancelConfirmBtn = async () => {
    const result = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 생성',
      message: '정말 취소하시겠습니까?',
    });

    if (!result) return;

    navigate(CATEGORY_CREATE_MANAGEMENT_URL_PATH);
  };

  return { onClickSaveConfirmBtn, onClickCancelConfirmBtn };
};

export default useCategoryCreateModal;
